<template>
  <div>
    <br>
    <!-- Page content -->
    <div class="card-body card-deck flex-column flex-xl-row">
      <!-- Users and Roles -->
      <permissionables-card @item-selected="itemSelected"></permissionables-card>
      <!-- Permissions -->
      <permissions-card :selectedItem="selectedItem" :selectedItemType="selectedItemType"></permissions-card>
    </div>
  </div>
</template>
<script>
import PermissionablesCard from "./components/PermissionablesCard";
import PermissionsCard from "./components/PermissionsCard";

export default {
  components: {
    PermissionablesCard,
    PermissionsCard,
  },
  data() {
    return {
      selectedItem: {},
      selectedItemType: "group",
    };
  },
  mounted() {
  },
  watch: {
    permissionsIds(np) {}
  },
  methods: {
    itemSelected(item, type) {
      this.selectedItem = item;
      this.selectedItemType = type;
    },
  },
};
</script>
